import { ISpeResponse } from './ISpe';
import { ITermsAcceptanceResponse } from './ITermsAcceptance';

// Modo de faturamento do tenant: um CNPJ só (comportamento atual) ou rateio entre SPEs.
export enum BillingModeEnum {
  SingleCompany = 1,
  SpeSplit = 2,
}

// Como o valor do plano se divide entre as SPEs.
// Uniform  = partes iguais, calculadas automaticamente ("Divisão igual" na UI)
// Custom   = peso explícito por SPE ("Divisão personalizada" na UI)
export enum RateioModeEnum {
  Uniform = 1,
  Custom = 2,
}

export interface IRateioShareResponse {
  SpeId: string;
  // Percentual com duas casas decimais. A soma de todos deve fechar 100.
  Weight: number;
  // Marca a SPE que absorveu o resto da divisão no modo Uniform, para que a
  // diferença de centavos seja auditável na conferência da nota.
  IsRoundingAdjusted: boolean;
}

export interface IRateioResponse {
  Mode: RateioModeEnum;
  Shares: IRateioShareResponse[];
}

export interface IBillingSplitResponse {
  BillingMode: BillingModeEnum;
  // Nulo quando BillingMode é SingleCompany.
  Rateio: IRateioResponse | null;
  Spes: ISpeResponse[];
  // Ciência da matriz nos Termos de Uso. Nulo se ainda não houve pedido.
  HeadquartersTermsAcceptance?: ITermsAcceptanceResponse | null;
}

export interface IRateioShareRequest {
  speId: string;
  weight: number;
}

export interface IRateioUpdateRequest {
  mode: RateioModeEnum;
  // Ignorado quando mode é Uniform — nesse caso os pesos são calculados.
  shares: IRateioShareRequest[];
}
